import React from 'react';
import ServicesPage from '../../components/Services/ServicesPage';
import ServiceImg1 from '../../assets/images/services/services-1-1.jpg';
import ServiceImg2 from '../../assets/images/services/services-1-2.jpg';
import ServiceImg3 from '../../assets/images/services/services-1-3.jpg';
import ServiceImg4 from '../../assets/images/services/services-1-4.jpg';
import ServiceImg5 from '../../assets/images/services/services-1-5.jpg';
import ServiceImg6 from '../../assets/images/services/services-1-6.jpg';

import ContainerShear from '../../assets/images/services/container-shear-12.png';
import HydraulicScrapBaler from '../../assets/images/services/hydraulic-scrap-baler.png';
import HeavyDutyScrapShear from '../../assets/images/services/heavy-duty-scrap-shear.png';
import Excavator from '../../assets/images/services/excavator.png';
import Magnet from '../../assets/images/services/MAGNET.png';
import VerticalScrapShear from '../../assets/images/services/vertical-scrap-shear.png';
import Fixboom from '../../assets/images/services/fixboom.png';
import DoubleShaft from '../../assets/images/services/double-shaft-shredder.png'
import Grab from '../../assets/images/services/GRAB.png';

const ServicesMain = () => {
  const services = [
    {

      imgSrc: ContainerShear,
      title: 'HORIZONTAL AUTOMATIC CONTAINER SHEARING MACHINE',
      link: '/horizontal-automatic-container-shear',
      description: 'Horizontal Automatic Container Shearing Machine is ideal for cutting the metal shaped in different',
    },
    {
      imgName: HydraulicScrapBaler,
      imgSrc: HydraulicScrapBaler,
      title: 'HYDRAULIC SCRAP BALER',
      link: '/hydraulic-scrap-baler',
      description: 'Hydraulic Scrap Baler is ideal for cutting the metal shaped in different cross sections',
    },
    // {
    //   imgName: HeavyDutyScrapShear,
    //   title: 'HEAVY DUTY SCRAP SHEAR',
    //   link: '/peak-performance-roofing',
    //   description: 'Heavy-duty scrap shear is a dynamic and heavy duty multi-tasking machine.',
    // },
    // {
    //   imgName: Excavator,
    //   imgSrc: Excavator,
    //   title: 'MOVABLE EXCAVATOR',
    //   link: '/movable-excavator',
    //   description: 'An excavator is a heavy-duty machine that is primarily used for loading large amounts....',
    // },
    {
      imgName: DoubleShaft,
      imgSrc: DoubleShaft,
      title: 'DOUBLE SHAFT SCRAP SHREDDER',
      link: '/double-shaft-shredder',
      description: 'A double shaft scrap shredder is a powerful industrial machine designed to shred various matierals ...',
    },
    {
      imgName: Magnet,
      imgSrc: Magnet,
      title: 'SCRAP MAGNET',
      link: '/scrap-magnet',
      description: 'A scrap magnet, also referred to as a scrap metal magnet, is a specialized electromagnet...',
    },
    {
      imgName: VerticalScrapShear,
      imgSrc: VerticalScrapShear,
      title: 'VERTICAL HEAVY DUTY SCRAP SHEARING MACHINE',
      link: '/vertical-scrap-shear',
      description: 'A Vertical Heavy Duty Scrap Shearing Machine is a robust and powerful machine....',
    },
    // {
    //   imgName: Fixboom,
    //   imgSrc: Fixboom,
    //   title: 'FIXED BOOM EXCAVATOR',
    //   link: '/fixed-boom-excavator',
    //   description: 'This type of fixed boom excavator is frequently used to feed scrap shear machines beneath...',
    // },
    {
      imgName: Grab,
      imgSrc: Grab,
      title: 'SCRAP GRABBER',
      link: '/grabber',
      description: 'A scrap grabber, also known as a scrap metal grabber or a hydraulic grabber, is a...',
    },


  ];
  return (
    <React.Fragment>
      {/*Services Page Start*/}

      <ServicesPage services={services} />
      {/*Services Page End*/}
    </React.Fragment>
  );
};

export default ServicesMain;
